import { WRAPPER } from '@/shared/styles/themes';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${WRAPPER}

  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-top: 24px;
    margin-left: 18px;
    margin-right: 18px;
    //padding: 0 18px;
  }

  ${({ $alignToLeft }) =>
    $alignToLeft &&
    `
      
      @media (max-width: 768px) {
        margin: 0;
      }
    `}
`;

export const SearchWrapper = styled.div`
  flex-basis: 313px;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    gap: 6px;
    position: relative;
    /* margin-bottom: 6px; */
    flex-basis: 0;
  }
`;

export const SelectsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 6px;
  }
`;

export const DeleteFilterWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    margin-top: 12px;
  }
`;

export const SearchGameWrapper = styled.div`
  @media (max-width: 768px) {
    min-width: 48px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  ${({ $searchFocused }) =>
    $searchFocused &&
    ` 
    // grid-template-columns:  auto auto;
    // margin-top:6px;
  `}
`;
